import { render, staticRenderFns } from "./AlertIcon.vue?vue&type=template&id=4d7d8558&scoped=true"
import script from "./AlertIcon.vue?vue&type=script&lang=js"
export * from "./AlertIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d7d8558",
  null
  
)

export default component.exports